/**
 * Pure content-hash helper (T-27's Files list this alongside the sha256
 * worker; this is the underlying algorithm both the worker wrapper
 * (`sha256-worker.ts`) and the retry-unit's part-delivery step import).
 * Uses SubtleCrypto, available in both Workers and Node's global `crypto`.
 */

async function getSubtle(): Promise<SubtleCrypto> {
  if (globalThis.crypto?.subtle) return globalThis.crypto.subtle;
  // Browsers always provide crypto.subtle; this fallback only engages in
  // non-browser test harnesses (jsdom doesn't implement SubtleCrypto) by
  // reaching into Node's own webcrypto implementation.
  const nodeCrypto = await import("node:crypto");
  return nodeCrypto.webcrypto.subtle as unknown as SubtleCrypto;
}

export async function sha256Hex(data: ArrayBuffer | Uint8Array): Promise<string> {
  const subtle = await getSubtle();
  const buf = data instanceof Uint8Array ? data.slice().buffer : data;
  const digest = await subtle.digest("SHA-256", buf);
  return [...new Uint8Array(digest)].map((b) => b.toString(16).padStart(2, "0")).join("");
}

export async function sha256HexOfBlob(blob: Blob): Promise<string> {
  return sha256Hex(await blob.arrayBuffer());
}
